<template>
    <div class="ah-page revenue-goal-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>{{ isEditMode ? "編輯" : "新增" }}營收目標</h1>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <el-form ref="form" label-width="180px" label-position="right">
                <div class="ah-panel">
                    <div class="panel-body">
                        <el-button class="cancel-btn" @click="$router.go(-1)">
                            返回列表
                        </el-button>
                        <el-form-item label="年份">
                            <el-select v-model="targetYear" placeholder="請選擇年份" @change="onChangeYear">
                                <el-option v-for="item in yearList" :key="item.value" :label="item.label" :value="item.value"> </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="營收目標">
                            <el-table v-loading="isTableLoading" :data="tableData" style="width: 100%" class="ah-el-data-table" empty-text="沒有資料" :row-class-name="tableRowClassName">
                                <el-table-column prop="month" label="月份"> </el-table-column>
                                <el-table-column prop="lastYearRevenue" :label="`${targetYearText} 年度營業收入`">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.lastYearRevenue" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="lastYearRevenueGoal" :label="`${targetYearText} 年度營收目標`">
                                    <template slot-scope="scope">
                                        <Money :v="scope.row.lastYearRevenueGoal" />
                                    </template>
                                </el-table-column>
                                <el-table-column prop="targetYearRevenueGoal" :label="`${targetYear} 年度營收目標`">
                                    <template slot-scope="scope">
                                        <Money v-if="scope.$index == 12" :v="scope.row.targetYearRevenueGoal" />

                                        <MoneyInput v-else v-model="scope.row.targetYearRevenueGoal" :disabled="!isTableEnabled" @change="onChangeInput" />
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-form-item>
                        <div class="detail-row right">
                            <el-button class="cancel-btn" @click="$router.go(-1)">
                                取消
                            </el-button>
                            <el-button v-if="isTableEnabled && !isQR()" :loading="isButtonLoading" type="primary" class="submit-btn" @click="onSubmit">
                                {{ isEditMode ? "儲存" : "新增" }}
                            </el-button>
                        </div>
                    </div>
                </div>
            </el-form>
        </div>
    </div>
</template>
<script>
import {
    map, find, sumBy, dropRight,
} from 'lodash';
import { monthOptions } from '@/assets/commonData/options';

export default {
    data() {
        return {
            isTableLoading: false,
            isButtonLoading: false,

            tableData: [],
            yearList: [],
            targetYear: null,

            isEditMode: false,
        };
    },
    created() {
        this.initData();
        this.initAsyncData();
    },
    computed: {
        isTableEnabled() {
            return !!this.targetYear;
        },
        targetYearText() {
            return this.targetYear ? this.targetYear - 1 : '--';
        },
    },
    methods: {
        initData() {
            const THIS_YEAR = new Date().getFullYear();
            for (let i = THIS_YEAR + 2; i >= THIS_YEAR - 10; i -= 1) {
                this.yearList.push({ value: i, label: i });
            }
            if (this.$route.name === 'revenue-goal-edit') {
                this.targetYear = Number(this.$route.params.year);
            }
        },
        async initAsyncData() {
            this.isTableLoading = true;
            let lastYearRevenue;
            let lastYearRevenueGoal;
            let targetYearRevenueGoal;
            if (this.isTableEnabled) {
                lastYearRevenue = (
                    await this.$api({
                        url: 'RevenueTargetSettingPage/GetMonthlyRevenue',
                        params: { Year: this.targetYear - 1 },
                        method: 'GET',
                    })
                ).data.incomeItems;

                lastYearRevenueGoal = (
                    await this.$api({
                        url: 'RevenueTargetSettingPage/GetSettings',
                        params: { Year: this.targetYear - 1 },
                        method: 'GET',
                    })
                ).data.settings;

                targetYearRevenueGoal = (
                    await this.$api({
                        url: 'RevenueTargetSettingPage/GetSettings',
                        params: { Year: this.targetYear },
                        method: 'GET',
                    })
                ).data.settings;

                this.isEditMode = !!targetYearRevenueGoal.length;
            }

            this.tableData = map(monthOptions, (item) => ({
                month: item.value,
                lastYearRevenue: find(lastYearRevenue, ['month', item.key])?.income || 0,
                lastYearRevenueGoal: find(lastYearRevenueGoal, ['month', item.key])?.kpi || 0,
                targetYearRevenueGoal: find(targetYearRevenueGoal, ['month', item.key])?.kpi || 0,
            }));

            this.tableData.push({
                month: '總計',
                lastYearRevenue: sumBy(this.tableData, 'lastYearRevenue'),
                lastYearRevenueGoal: sumBy(this.tableData, 'lastYearRevenueGoal'),
                targetYearRevenueGoal: sumBy(this.tableData, 'targetYearRevenueGoal'),
            });

            this.isTableLoading = false;
        },
        onChangeYear(year) {
            this.$router.replace({
                name: 'revenue-goal-edit',
                params: { year },
            });
            this.initAsyncData();
        },
        onChangeInput() {
            this.tableData[12].targetYearRevenueGoal = sumBy(dropRight(this.tableData), 'targetYearRevenueGoal');
        },
        async onSubmit() {
            this.isButtonLoading = true;
            try {
                await this.$api({
                    url: 'RevenueTargetSettingPage/UpsertSettings',
                    method: 'POST',
                    data: {
                        year: this.targetYear,
                        settings: map(dropRight(this.tableData), (item, i) => ({
                            month: i + 1,
                            kpi: item.targetYearRevenueGoal,
                        })),
                    },
                });
                this.$router.push({ name: 'revenue-goal' });
            } catch (e) {
                console.log(e);
            } finally {
                this.isButtonLoading = false;
            }
        },
        tableRowClassName({ rowIndex }) {
            if (rowIndex === 12) {
                return 'last-row';
            }
            return '';
        },
    },
};
</script>

<style lang="scss" scoped>
.detail-row {
    display: flex;
    justify-content: flex-end;
    .cancel-btn {
        width: 100px;
    }
    .submit-btn {
        width: 195px;
    }
}
</style>

<style lang="scss">
.revenue-goal-page {
    .el-table .last-row {
        background-color: #c4c4c43a;
    }
    .el-input__inner {
        height: 35px;
    }
    .el-table__row td {
        padding: 6px 0;
        height: 48px;
    }
    .el-table__header th {
        padding: 0;
    }
}
</style>
